/**
 * Human size for an archive: whole megabytes below a gigabyte, one decimal
 * above. Used by the progress snackbar and the recipients dialog.
 * @param {number} bytes
 * @returns {string}
 */
export const formatArchiveSize = (bytes) => {
  const gigabytes = bytes / 1024 ** 3;

  if (gigabytes >= 1) {
    return `${gigabytes.toFixed(1)} GB`;
  }

  return `${Math.max(1, Math.round(bytes / 1024 ** 2))} MB`;
};
